import { render, staticRenderFns } from "./mailDetail.vue?vue&type=template&id=387e48e4&scoped=true"
import script from "./mailDetail.vue?vue&type=script&lang=js"
export * from "./mailDetail.vue?vue&type=script&lang=js"
import style0 from "./mailDetail.vue?vue&type=style&index=0&id=387e48e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e48e4",
  null
  
)

export default component.exports